import React from "react";

export function DiamondIcon({
  className,
  stroke,
  label,
  showDraggedOverHighlight,
}: {
  className: string;
  stroke: number;
  label?: string;
  showDraggedOverHighlight?: boolean;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64px"
      height="64px"
      fill="none"
      viewBox="0 0 88 88"
      className={className}
    >
      <defs>
        <filter id="dragged-over-highlight">
          <feDropShadow
            dx="0"
            dy="0"
            stdDeviation="6"
            floodColor="hsl(35, 100%, 47%)" // hsl(35, 100%, 87%)
          />
        </filter>
      </defs>
      <path
        fill="#fff"
        stroke="currentColor"
        filter={showDraggedOverHighlight ? "url(#dragged-over-highlight)" : ""}
        strokeWidth={stroke}
        d="M37.212 6.788c2.376-2.376 3.564-3.564 4.934-4.01a6 6 0 013.708 0c1.37.446 2.558 1.634 4.934 4.01l30.424 30.424c2.376 2.376 3.564 3.564 4.01 4.934a6 6 0 010 3.708c-.446 1.37-1.634 2.558-4.01 4.934L50.788 81.212c-2.376 2.376-3.564 3.564-4.934 4.01a6 6 0 01-3.708 0c-1.37-.446-2.558-1.634-4.934-4.01L6.788 50.788c-2.376-2.376-3.564-3.564-4.01-4.934a6 6 0 010-3.708c.446-1.37 1.634-2.558 4.01-4.934L37.212 6.788z"
      ></path>
      {!!label && (
        <text x="6" y="50" font-family="Verdana" font-size="16" fill="blue">
          {label}
        </text>
      )}
    </svg>
  );
}
